"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";
import styled from "styled-components";

import { SVGIcon } from "../SVGIcon";

type Direction = "up" | "down" | "left" | "right" | "upAndRight";

export interface IChevronProps extends SVGIcon.IProps {
  direction: Direction;
}

const DirectionalIcon = styled(SVGIcon)<{ direction: Direction }>`
  transform: rotateZ(
    ${({ direction }) => {
      switch (direction) {
        case "right":
          return "0deg";
        case "down":
          return "90deg";
        case "left":
          return "180deg";
        case "up":
        default:
          return "270deg";
      }
    }}
  );
`;

export const Chevron = React.memo(
  ({
    direction,
    ref,
    className,
    ...props
  }: IChevronProps & React.RefAttributes<SVGElement>) => {
    return (
      <DirectionalIcon
        direction={direction}
        viewBox="0 0 24 24"
        fill="none"
        ref={ref}
        className={legacyIconCls(className)}
        {...props}
      >
        <path
          d="M6.60693 0.857147L17.1429 11.3931C17.2228 11.4728 17.2861 11.5674 17.3293 11.6715C17.3725 11.7756 17.3948 11.8873 17.3948 12C17.3948 12.1127 17.3725 12.2244 17.3293 12.3285C17.2861 12.4327 17.2228 12.5272 17.1429 12.6069L6.60693 23.1429"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </DirectionalIcon>
    );
  }
);

if (process.env.NODE_ENV !== "production") {
  Chevron.displayName = `ArrowIcon`;
}
